export const SETUP_PROFILE_SUCCESSFUL = "setup_profile_successfull"
export const REGISTER_USER = "register_user"
export const REGISTER_USER_FAILED = "register_user_failed"
